export class StoppageTypeDto {
  stoppageTypeId!: number;
  stoppageType!: string;
  colourHex?: string;
  isDowntime?: boolean;

  constructor(data: Partial<StoppageTypeDto>) {
    Object.assign(this, data);
  }
}